var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.profileLoaded && _vm.haveNeededField
            ? _vm._t("value", null, null, _vm.profile)
            : !_vm.haveNeededField && _vm.profileLoaded && !_vm.alwaysShowCta
            ? _c(
                "a",
                {
                  staticClass: "account-information-field-cta__add",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("open")
                    },
                  },
                },
                [
                  _c("div", {
                    staticClass: "account-information-field-icon icon-add-gold",
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.tc("booking.add")) +
                      " " +
                      _vm._s(
                        _vm.fieldPlaceholder
                          ? _vm.fieldPlaceholder
                          : _vm.fieldLabel
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _c("div", { staticClass: "loader" }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.alwaysShowCta
        ? _c(
            "a",
            {
              staticClass: "account-information-field-cta__add",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("open")
                },
              },
            },
            [
              _c("div", {
                staticClass: "account-information-field-icon icon-add-gold",
              }),
              _vm._v(
                "\n    " +
                  _vm._s(_vm.tc("booking.add")) +
                  " " +
                  _vm._s(
                    _vm.fieldPlaceholder ? _vm.fieldPlaceholder : _vm.fieldLabel
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }